import QueryString from 'qs'
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { getSearchExceptFilterList, getSearchProduct } from '../../api/product'
import { Button } from '../../components/Button'
import { colorObj } from '../../components/color'
import ProductCenterModal from '../../components/product/ProductCenterModal'
import ProductFilterCenterModal from '../../components/product/ProductFilterCenterModal'
import ProductFilterModal from '../../components/product/ProductFilterModal'
import ProductHeader from '../../components/product/ProductHeader'
import ProductItem from '../../components/product/ProductItem'
import ProductListItem from '../../components/product/ProductListItem'
import ProductModal from '../../components/product/ProductModal'
import ProductSortModal from '../../components/product/ProductSortModal'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { setRecentlySearchWord } from '../../js/script'
import {
  AutoSearchContent,
  AutoSearchContentBox,
  AutoSearchWrap,
  SearchBar,
  SearchBarWrap,
  SearchIcon,
  SearchResetBtn,
  SearchWrap,
} from './Search'
import { PathContext } from '../../App'

export default function SearchResult() {
  const [keyword, setKeyword] = useState<string>('')
  const [keyItems, setKeyItems] = useState<any>([])
  const [isValue, setIsValue] = useState<boolean>(true)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [type, setType] = useState<string>('thumb')
  const [listItem, setListItem] = useState<any>([]) //상품 아이템
  const [sortKeyword, setSortKeyword] = useState<string>('RECENT_PRODUCT') //정렬값
  const [sortKeywordLabel, setSortKeywordLabel] = useState<string>('최신순') //정렬 텍스트
  const [sortDirection, setSortDirection] = useState<string>('DESC') //정렬 내림차순?오름차순
  const [isModal, setIsModal] = useState<boolean>(false)
  const [isFilter, setIsFilter] = useState<boolean>(false)
  const [selectProductNo, setSelectProductNo] = useState<string>('')
  const [defaultKeyword, setDefaultKeyword] = useState<string>('')
  const [keywordChange, setKeywordChange] = useState<boolean>(false)
  const [isSort, setIsSort] = useState<boolean>(false)
  const [getMax, setGetMax] = useState<number>(10000000)
  const [getMin, setGetMin] = useState<number>(0)
  const [freeCheck, setFreeCheck] = useState<boolean>(false)
  const [filterApply, setFilterApply] = useState<boolean>(false)
  const [brandArray, setBrandArray] = useState<any>([])
  const [filterSearch, setFilterSearch] = useState([])
  const [filterMin, setFilterMin] = useState<number>(0)
  const [filterMax, setFilterMax] = useState<number>(10000000)
  const [max, setMax] = useState<number>(10000000)
  const [min, setMin] = useState<number>(0)
  const [filterTotal, setFilterTotal] = useState<number>(0)
  const [autoBox, setAutoBox] = useState<boolean>(true)
  const [cartIdx, setCartIdx] = useState<number>(0)
  const [page, setPage] = useState<number>(1) //현재 페이지
  const { isAppView } = useAppContext()
  const { allSearch } = useContext(PathContext)
  const { setIsLottie } = useCommonContext()
  const searchRef = useRef<HTMLInputElement>(null)
  const itemRef = useRef<any>(null)
  const preventRef = useRef(true) //옵저버 중복 실행 방지
  const endRef = useRef(false) //모든 글 로드 확인
  const obsRef = useRef<HTMLDivElement>(null) //observer Element
  const params = useParams()
  const location = useLocation()
  const navigate = useNavigate()

  const onChangeData = (e: React.FormEvent<HTMLInputElement>) => {
    setKeyword(e.currentTarget.value)
    if (e.currentTarget.value.length === 0) {
      setAutoBox(false)
      setIsValue(false)
    } else {
      setAutoBox(true)
      setIsValue(true)
    }
    setKeywordChange(true)
  }

  useEffect(() => {
    if (defaultKeyword && totalCount) {
      const gtmNavigateClick: DataLayerArgs = {
        dataLayer: {
          event: 'view_search_results',
          event_info: {
            search_term: defaultKeyword,
            search_results_count: totalCount,
          },
        },
      }
      if (isAppView) {
        sendSetAppsflyerEvent({
          eventName: 'view_search_results',
          eventType: {
            search_term: defaultKeyword,
            search_results_count: totalCount,
          },
        })
      } else {
        TagManager.dataLayer(gtmNavigateClick)
      }
    }
  }, [totalCount, defaultKeyword])

  useEffect(() => {
    setGetMax(10000000)
    setGetMin(0)
    setFreeCheck(false)
    setTimeout(() => {
      setFilterApply((prev: boolean) => !prev)
    }, 200)
  }, [])

  useEffect(() => {
    if (filterApply && !isFilter) {
      setFilterMin(getMin)
      setFilterMax(getMax)
    }
  }, [isFilter, filterApply])

  useEffect(() => {
    if (brandArray || freeCheck) {
      if (freeCheck) {
        setFilterTotal(brandArray.length + 1)
      } else {
        setFilterTotal(brandArray.length)
      }
    }
    if (filterMax !== 10000000 || filterMin !== 0) {
      setFilterTotal((prev: number) => prev + 1)
    }
  }, [brandArray, freeCheck, filterMax, filterMin])

  useEffect(() => {
    setListItem([])
  }, [])

  const fetchData = () => {
    const filteredArray = allSearch.filter((el: any) => el.productName.includes(keyword))
    setFilterSearch(filteredArray) // 상태를 한 번만 업데이트
  }

  const updateData = async () => {
    fetchData()
    const res = keyItems
  }

  useEffect(() => {
    const debounce = setTimeout(() => {
      if (keyword) updateData()
    }, 100)
    if (keyword.length === 0) {
      setKeyItems([])
    }
    return () => {
      clearTimeout(debounce)
    }
  }, [keyword]) //키워드가 변경되면 api를 호출

  useEffect(() => {
    setFilterApply(false)
  }, [isFilter])

  useEffect(() => {
    const query = QueryString.parse(location.search, {
      ignoreQueryPrefix: true,
    })
    if (query.keyword !== undefined) {
      setDefaultKeyword(query.keyword as string)
      setKeywordChange(false)
      setIsValue(true)
    }
  }, [])

  // useEffect(() => {
  //   //옵저버 생성
  //   if (listItem) {
  //     const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 })
  //     if (obsRef.current) observer.observe(obsRef.current)
  //     return () => {
  //       observer.disconnect()
  //     }
  //   }
  // }, [listItem, itemRef.current])

  useEffect(() => {
    if (listItem.length > 0) {
      const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 })
      if (obsRef.current) {
        observer.observe(obsRef.current)

        // 초기 트리거 방지: 대상 요소가 뷰포트에 있는지 확인
        const isIntersecting = obsRef.current.getBoundingClientRect().top < window.innerHeight
        if (isIntersecting) {
          preventRef.current = false // 초기 트리거 방지
        }
      }
      return () => {
        observer.disconnect()
      }
    }
  }, [listItem])

  // const obsHandler = (entries: any) => {
  //   //옵저버 콜백함수
  //   const target = entries[0]
  //   if (!endRef.current && target.isIntersecting && preventRef.current) {
  //     //옵저버 중복 실행 방지
  //     preventRef.current = false //옵저버 중복 실행 방지
  //     setPage((prev) => prev + 1) //페이지 값 증가
  //   }
  // }

  const obsHandler = (entries: any) => {
    const target = entries[0]
    if (!endRef.current && target.isIntersecting && preventRef.current) {
      preventRef.current = false // 중복 실행 방지
      setPage((prev) => prev + 1) // 페이지 값 증가
    }
  }

  const getPost = useCallback(async () => {
    try {
      preventRef.current = true
      const keyword = defaultKeyword.replaceAll(',', ' ')
      const orderBy = sortKeyword
      const brandList = brandArray.join(',')
      const orderDirection = sortDirection

      try {
        const { data } = await getSearchProduct(keyword, orderBy, page, getMin, getMax, brandList, orderDirection)

        if (page === 1) {
          setListItem(data.items)
        } else {
          setListItem((prev: any) => [...prev, ...data.items])
        }
        setTotalCount(data.totalCount)

        // 마지막 페이지인지 확인 후 설정
        endRef.current = data.pageCount <= page
        setIsLottie(false)
      } catch (error) {
        console.error('Error fetching search results:', error)
        setTotalCount(0)
      }
    } catch (e) {
      console.error(e)
    }
  }, [page, defaultKeyword, sortDirection, sortKeyword, filterApply])

  // useEffect(() => {
  //   if (defaultKeyword) {
  //     preventRef.current = true
  //     getPost()
  //   }
  // }, [page, defaultKeyword, sortDirection, sortKeyword, filterApply])

  useEffect(() => {
    if (defaultKeyword || sortDirection || sortKeyword || filterApply) {
      if (page !== 1) {
        setPage(1) // 페이지 초기화
      }
      setListItem([]) // 리스트 초기화
    }
  }, [defaultKeyword, sortDirection, sortKeyword, filterApply])

  useEffect(() => {
    if (defaultKeyword && page >= 1) {
      preventRef.current = true
      getPost()
    }
  }, [page, defaultKeyword, sortDirection, sortKeyword, filterApply])

  // useEffect(() => {
  //   if (page !== 1) setPage(1)
  //   setListItem([])
  // }, [defaultKeyword, sortDirection, sortKeyword, filterApply])

  // 검색결과 없을 때 박스 높이 조절
  useEffect(() => {
    const contentsWrap = document.querySelector('.contents_wrap')
    if (listItem?.length === 0) {
      contentsWrap?.classList?.add('full')
    } else {
      contentsWrap?.classList?.remove('full')
    }
  }, [])

  useEffect(() => {
    setAutoBox(false)
    document.body.style.overflow = 'unset'
  }, [params])

  function isFirstCharSpace(input: any) {
    return input.charAt(0) === ' '
  }

  useEffect(() => {
    if (keyword) {
      document.body.style.overflow = 'hidden'
      return () => {
        document.body.style.overflow = 'unset'
      }
    }
  }, [keyword])

  return (
    <>
      <div className='main_wrap'>
        <div className={listItem.length !== 0 ? 'contents_wrap' : 'contents_wrap full'}>
          {!isMobile && (
            <PageTitle>
              <SearchKeyWord>{defaultKeyword}</SearchKeyWord>에 대한 검색 결과
            </PageTitle>
          )}
          <SearchWrap>
            {isMobile && (
              <SearchBarWrap style={{}} className='search_inp'>
                <div className='inner'>
                  <SearchBar
                    ref={searchRef}
                    className='search_result_input'
                    type='search'
                    value={keywordChange ? keyword : defaultKeyword}
                    placeholder='검색어를 입력해 보세요.'
                    onChange={onChangeData}
                    onFocus={() => {
                      setIsValue(true)
                    }}
                    onKeyUp={(e) => {
                      if (e.key === 'Enter') {
                        if (keyword && !isFirstCharSpace(keyword)) {
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${
                                process.env.REACT_APP_SHOP_URL
                              }/search/searchResult?keyword=${keyword.replaceAll(',', ' ')}`,
                            })
                          } else {
                            navigate(`/search/searchResult?keyword=${keyword.replaceAll(',', ' ')}`)
                          }

                          setRecentlySearchWord(keyword)
                        } else {
                          alert('첫자리 공백은 검색이 불가합니다.')
                        }
                      }
                    }}
                  />
                  {isValue && (
                    <SearchResetBtn>
                      <img
                        src='/images/icon_search_delete.svg'
                        alt='검색어 초기화'
                        onClick={(e) => {
                          e.preventDefault()
                          setDefaultKeyword('')
                          setIsValue(false)
                          setTotalCount(0)
                          searchRef.current?.focus()
                          setKeyword('')
                        }}
                      />
                    </SearchResetBtn>
                  )}
                  <SearchIcon
                    src={`/images/icon_search.png`}
                    onClick={() => {
                      if (keyword) {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${
                              process.env.REACT_APP_SHOP_URL
                            }/search/searchResult?keyword=${keyword.replaceAll(',', ' ')}`,
                          })
                        } else {
                          navigate(`/search/searchResult?keyword=${keyword.replaceAll(',', ' ')}`)
                        }
                        setRecentlySearchWord(keyword)
                      }
                    }}
                  />
                </div>
              </SearchBarWrap>
            )}
            {isMobile && keyword && autoBox && (
              <AutoSearchWrap>
                {filterSearch?.map((el: any, index: number) => {
                  const firstEIndex = el.productName.indexOf(keyword)
                  const keywordNumber = keyword.length
                  const beforeE = el.productName.slice(0, firstEIndex)
                  const afterE = el.productName.slice(firstEIndex + keywordNumber)
                  return (
                    <AutoSearchContentBox
                      key={`${el.productNo}-${index}`}
                      onClick={() => {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${
                              process.env.REACT_APP_SHOP_URL
                            }/search/searchResult?keyword=${el.productName.replaceAll(',', ' ')}`,
                          })
                        } else {
                          navigate(`/search/searchResult?keyword=${el.productName.replaceAll(',', ' ')}`)
                        }

                        setKeyword('')
                        setRecentlySearchWord(el.productName)
                      }}
                    >
                      <AutoSearchContent>
                        {beforeE}
                        <span style={{ color: colorObj.colPointBlue }}>{keyword}</span>
                        {afterE}
                      </AutoSearchContent>
                    </AutoSearchContentBox>
                  )
                })}
              </AutoSearchWrap>
            )}
            <SearchResultWrap>
              {/* 상품목록 header */}
              <ProductHeader
                totalCount={totalCount}
                filterTotal={filterTotal}
                type={type}
                setType={setType}
                setIsSort={setIsSort}
                sortKeywordLabel={sortKeywordLabel}
                setIsFilter={setIsFilter}
                setSortDirection={setSortDirection}
                sortDirection={sortDirection}
                setSortKeywordLabel={setSortKeywordLabel}
                isSort={isSort}
                sortKeyword={sortKeyword}
                setSortKeyword={setSortKeyword}
              ></ProductHeader>

              {/* 상품 Item Wrap */}
              {listItem.length !== 0 ? (
                <>
                  <div ref={itemRef}>
                    <div className={type === 'thumb' ? 'product_wrap' : 'product_wrap list'}>
                      {type === 'thumb'
                        ? listItem.map((el: any, idx: number) => {
                            return (
                              <ProductItem
                                item={el}
                                key={`${el.productNo}-${idx}`}
                                setIsModal={setIsModal}
                                setSelectProductNo={setSelectProductNo}
                                idx={idx}
                                totalCount={totalCount}
                                defaultKeyword={defaultKeyword}
                                setCartIdx={setCartIdx}
                              />
                            )
                          })
                        : null}
                      {type === 'list'
                        ? listItem.map((el: any, idx: number) => {
                            return (
                              <ProductListItem
                                item={el}
                                key={el.productNo}
                                setIsModal={setIsModal}
                                setSelectProductNo={setSelectProductNo}
                                listItem={listItem}
                                idx={idx}
                                totalCount={totalCount}
                                defaultKeyword={defaultKeyword}
                                setCartIdx={setCartIdx}
                              />
                            )
                          })
                        : null}
                    </div>
                  </div>
                </>
              ) : (
                <NoContentWrap>
                  <NoContentCotentWrap2>
                    <img src='/images/empty_logo.png' alt='' />
                    <NoContentContent>검색결과가 없습니다.</NoContentContent>
                  </NoContentCotentWrap2>
                </NoContentWrap>
              )}
            </SearchResultWrap>
            {isModal ? (
              isMobile ? (
                <ProductModal
                  setIsModal={setIsModal}
                  headerText={'옵션선택'}
                  selectProductNo={selectProductNo}
                  listItem={listItem}
                ></ProductModal>
              ) : (
                <ProductCenterModal
                  setIsModal={setIsModal}
                  headerText={'옵션선택'}
                  selectProductNo={selectProductNo}
                  listItem={listItem}
                ></ProductCenterModal>
              )
            ) : null}
          </SearchWrap>
        </div>
      </div>
      {isSort && isMobile && (
        <ProductSortModal
          headerText='정렬'
          setIsModal={setIsSort}
          setSortKeyword={setSortKeyword}
          sortKeyword={sortKeyword}
          setSortKeywordLabel={setSortKeywordLabel}
          setSortDirection={setSortDirection}
          sortDirection={sortDirection}
        ></ProductSortModal>
      )}
      {isFilter &&
        (isMobile ? (
          <ProductFilterModal
            isCategoryModal={isFilter}
            setIsCategoryModal={setIsFilter}
            setFreeCheck={setFreeCheck}
            setGetMax={setGetMax}
            setGetMin={setGetMin}
            setFilterApply={setFilterApply}
            setBrandArray={setBrandArray}
            brandArray={brandArray}
            filterMax={filterMax}
            filterMin={filterMin}
            freeCheck={freeCheck}
            max={max}
            setMax={setMax}
            min={min}
            setMin={setMin}
          ></ProductFilterModal>
        ) : (
          <ProductFilterCenterModal
            isCategoryModal={isFilter}
            setIsCategoryModal={setIsFilter}
            setFreeCheck={setFreeCheck}
            setGetMax={setGetMax}
            setGetMin={setGetMin}
            freeCheck={freeCheck}
            setFilterApply={setFilterApply}
            setBrandArray={setBrandArray}
            brandArray={brandArray}
            filterMax={filterMax}
            filterMin={filterMin}
            max={max}
            setMax={setMax}
            min={min}
            setMin={setMin}
          ></ProductFilterCenterModal>
        ))}
      <div ref={obsRef}></div>
    </>
  )
}

export const SearchResultWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export const SearchKeyWord = styled.span`
  color: var(--colPointBlue);
`

export const NoContentWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`

export const NoContentContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NoContentTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`
export const NoContentContent = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--colGray5);
  text-align: center;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`
export const NoContentCotentWrap2 = styled.div`
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 80px 0 100px 0;
  & img {
    width: 85px;
    height: 85px;
  }
  @media screen and (min-width: 768px) {
    & img {
      width: 108px;
      height: 108px;
    }
  }
`
export const NoContentBtn = styled(Button)`
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 35px;
  color: var(--colWhite);
  background: var(--colBlack);
  border-radius: 76px;
  line-height: 20px;
  margin-top: 20px;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding: 14px 40px;
    margin-top: 32px;
    cursor: pointer;
  }
`
